<template>
  <v-card class="bordered-card update-company">
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Update Company
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title class="pb-0">
      <v-layout>
        <v-flex xs4>
          <v-card flat>
            <v-select
              v-model="datasource"
              :items="datasources"
              label="Select datasource"
              item-text="text"
              item-value="value"
            />
          </v-card>
        </v-flex>
        <v-flex xs4 class="mr-4" style="margin-left: auto">
          <v-card flat>
            <v-text-field
              append-icon="search"
              label="Search"
              clear-icon
              clearable
              single-line
              hide-details
              v-model="search"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-container fluid>
      <v-data-table
        :headers="headers"
        :items="companies"
        :loading="tableLoading"
        :pagination.sync="tablePagination"
        :total-items="totalData"
        :rows-per-page-items="[15, 25, 50, 100]"
      >
        <template slot="items" slot-scope="props">
          <td>
            {{ props.item.companylegalname }}
          </td>
          <td>
            {{ props.item.streetaddress }}
          </td>
          <td>
            <v-menu bottom left>
              <v-btn icon slot="activator" class="darken-1" flat="flat">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title
                    dark
                    @click.prevent="viewCompany(props.item)"
                    >View</v-list-tile-title
                  >
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title
                    dark
                    @click.prevent="editCompany(props.item)"
                    >Edit</v-list-tile-title
                  >
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title
                    dark
                    @click.prevent="deleteCompany(props.item)"
                    >Delete</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </template>
      </v-data-table>
      <!-- <kendo-table
        :kendo-schema="kendoSchema"
        ref="kendoTable"
        :url="query"
        :download-full-data="true"
      /> -->
    </v-container>
    <company-modal
      :refreshTable="refreshTable"
      :show="companyModalDialog"
      :id="companyId"
      :readonly="companyModalReadonly"
      @closeModal="closeModal"
    />
    <delete-company-modal
      :show="deleteCompanyModalDialog"
      :id="companyId"
      :deleteCompany="deleteCompanyAction"
      @closeModal="closeModal"
    />
  </v-card>
</template>

<script>
import axios from "axios";
import KendoTable from "@/components/KendoTable.vue";
import CompanyModal from "../Components/CompanyModal.vue";
import DeleteCompanyModal from "../Components/DeleteCompanyModal.vue";

export default {
  components: {
    KendoTable,
    CompanyModal,
    DeleteCompanyModal,
  },
  data() {
    return {
      search: "",
      companies: [],
      tablePagination: {},
      totalData: 0,
      tableLoading: true,
      deleteCompanyModalDialog: false,
      companyModalDialog: false,
      companyModalReadonly: false,
      companyId: null,
      datasource: "USASpending.Gov.Exchange_app.community-exchange",
      datasources: [
        {
          text: "All",
          value:
            "Community_app.GTPAC_Neoserra.USASpending.Gov.Exchange_app.community-exchange",
        },
        {
          text: "GTPAC Companies",
          value: "GTPAC_Neoserra.Community_app.community-exchange",
        },
        {
          text: "Exchange Companies",
          value: "USASpending.Gov.Exchange_app.community-exchange",
        },
        {
          text: "Community & Exchange Companies",
          value: "community-exchange",
        },
      ],
      headers: [
        {
          text: "Company",
          value: "companylegalname",
        },
        {
          text: "Address",
          value: "streetaddress",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      link: "https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=USASpending.Gov.Exchange_app.community-exchange&sort[0][field]=companylegalname&sort[0][dir]=ASC",
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(val) {
        const hash = val.hash.replace("#action=", "");
        let type = hash.slice(0, 4);
        let companyId = hash.slice(5, hash.length);
        if (type === "view" || type === "edit") {
          this.companyModalReadonly = type === "view";
          this.companyId = companyId;
          this.companyModalDialog = true;
          return;
        }
        type = hash.slice(0, 6);
        companyId = hash.slice(7, hash.length);
        if (type === "delete") {
          this.companyId = companyId;
          this.deleteCompanyModalDialog = true;
        }
      },
    },
    search(val) {
      if (val) {
        this.link = encodeURI(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?companylegalname=${val}&datasource=${this.datasource}`
        );
        return;
      }
      this.link = encodeURI(
        `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=${this.datasource}`
      );
      return;
    },
    datasource(val) {
      if (this.search) {
        this.link = encodeURI(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?companylegalname=${this.search}&datasource=${val}`
        );
        return;
      }
      this.link = encodeURI(
        `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2?datasource=${val}`
      );
    },
    link: {
      immediate: true,
      handler(val) {
        return this.getCompanies(val);
      },
    },
    tablePagination: {
      deep: true,
      immediate: true,
      handler(pagination) {
        this.getCompanies(this.link);
      },
    },
  },
  computed: {
    query() {
      return this.link;
    },
  },
  methods: {
    editCompany(company) {
      const companyId = company._id;
      const type = "edit";
      window.location.hash = `#action=${type}-${companyId}`;
    },
    viewCompany(company) {
      const companyId = company._id;
      const type = "view";
      window.location.hash = `#action=${type}-${companyId}`;
    },
    deleteCompany(company) {
      const companyId = company._id;
      const type = "delete";
      window.location.hash = `#action=${type}-${companyId}`;
    },
    async getCompanies(link) {
      try {
        this.tableLoading = true;
        const { rowsPerPage, page } = this.tablePagination;
        const params = {
          take: rowsPerPage || 15,
          page: page || 1,
          skip: rowsPerPage ? rowsPerPage * (parseInt(page) - 1) : 0,
        };
        const { data } = await axios.get(link, {
          params,
        });
        this.companies = data.data;
        this.totalData = data.total;
      } catch (error) {
      } finally {
        this.tableLoading = false;
      }
    },
    refreshTable() {
      this.getCompanies(this.link);
    },
    deleteCompanyAction(id) {
      const uri = `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2/${id}`;
      return axios
        .delete(uri)
        .then(() => {
          this.closeModal("deleteCompanyModalDialog");
          this.$store.dispatch("triggerSnackbar", {
            text: "Company deleted successfully.",
            active: true,
            timeout: 7000,
          });
        })
        .catch(() => {
          this.link = this.link;
          this.closeModal("deleteCompanyModalDialog");
          this.$store.dispatch("triggerSnackbar", {
            text: "An error occured while deleting the company. Please Try again later.",
            active: true,
            timeout: 8000,
          });
        });
    },
    closeModal(val) {
      window.location.hash = "";
      this[val] = false;
      this.getCompanies(this.link);
    },
  },
};
</script>

<style>
.update-company .input-group--select {
  margin-top: initial !important;
}
</style>



// WEBPACK FOOTER //
// UpdateCompany.vue?8524d6ca